function NXFilter({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
    >
      <g clipPath="url(#clip0_4227_3351)">
        <path
          d="M0.857147 2.57146V21.4286C0.857147 22.3754 1.62466 23.1429 2.57143 23.1429H21.4286C22.3754 23.1429 23.1429 22.3754 23.1429 21.4286V2.57146C23.1429 1.62469 22.3754 0.857178 21.4286 0.857178H2.57143C1.62466 0.857178 0.857147 1.62469 0.857147 2.57146Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.71429 18.8571V10.2856"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.7143 10.2857C9.13446 10.2857 10.2857 9.13442 10.2857 7.71425C10.2857 6.29409 9.13446 5.14282 7.7143 5.14282C6.29413 5.14282 5.14287 6.29409 5.14287 7.71425C5.14287 9.13442 6.29413 10.2857 7.7143 10.2857Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.2857 5.14282V10.2857"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.2857 15.4287V18.8573"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.2857 15.4285C17.7058 15.4285 18.8572 14.2772 18.8572 12.8571C18.8572 11.4369 17.7058 10.2856 16.2857 10.2856C14.8656 10.2856 13.7143 11.4369 13.7143 12.8571C13.7143 14.2772 14.8656 15.4285 16.2857 15.4285Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4227_3351">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default NXFilter;
